import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './MainPages.css';

export default function Legislacao() {
    return (
        <Row>
            <Col xs="12">
                <h1>Legislação</h1>
                <h3>Consulte:</h3>
            </Col>
            <Col xs="12">
                <a href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            L.A.I. Federal
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/decreto/d7724.htm" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Decreto Federal
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://legis.alepe.pe.gov.br/texto.aspx?id=1605&tipo=" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            L.A.I. Poder Executivo Estadual
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://legis.alepe.pe.gov.br/texto.aspx?id=2576&tipo=" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Decreto Poder Executivo Estadual
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://legis.alepe.pe.gov.br/texto.aspx?id=4481&tipo=" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            L.A.I. Alepe
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="http://legis.alepe.pe.gov.br/" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Alepe Legis
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://legis.alepe.pe.gov.br/texto.aspx?id=10401&tipo=" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Código de Ética Parlamentar
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://legis.alepe.pe.gov.br/texto.aspx?id=10727&tipo=" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Estatuto dos Servidores Públicos
                        </Card.Body>
                    </Card>
                </a>
            </Col>
        </Row>
    );
}
